import Button from '../../components/reusableElementsComponents/Button';
import HomeQuickStart from '../../components/homeComponents/HomeQuickStart';
import { useLocation } from 'react-router-dom';
import {Link} from 'react-router-dom';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import {useSelector} from "react-redux";
import { t } from '../../content';


function Onboarding({userRole}) {
    const companyIsActive = useSelector(state => state.company.isActive);
    const location = useLocation();
    const currentURL = location.pathname;

    return (
        <div className='page-with-notification'>
            <div className="notification">
                <Box>
                    <Collapse in={!companyIsActive}>
                        <Alert
                            className='inactive-alert'
                            variant="standard"
                            severity="info"

                            sx={{mb: 2}}
                        >
                            <strong>{t('auth.register.pendingActivation')}</strong>
                        </Alert>
                    </Collapse>
                </Box>
            </div>

            {currentURL !== "/faq-page" ? (            
                <div className='onboarding-page'>
                <div className="onboarding-page-wrapper">
                    <HomeQuickStart userRole={userRole}/>
                    
                    <div className="button-wrapper mar-20 top">
                        <Button btnstyle={'mazhrBtn default-green'}>
                            <Link to="/faq-page">{t('auth.register.contactUs')}</Link>
                        </Button>
                    </div>

                </div>
            </div>): (
                <div className='onboarding-page-help-center'>
                <div className='onboarding-page-wrapper'>
                    <div className='copy'>
                    </div>

                </div>
                </div>

            )}
        </div>
    )
}

export default Onboarding;
